// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b234a7ba","209":"978fa121","256":"b6edd6ca","326":"a61eef01","332":"696ab9d3","500":"3fc9a7c8","544":"a32db8db","620":"9bb978fd","632":"8e54f87e","668":"0ad57a18","832":"8421a9d1","904":"24be2989"}[chunkId] + ".chunk.js";
};